<template>

      <div class="banner">
        <div class="downloadbutton win">
          <a
            :href="`${this.$api.getBaseUrl()}/api/plugin/video-tool/download-latest`"
            @click="download('win')"
          >Win端下载</a>
        </div>
        <div class="downloadbutton mac">
          <a
            :href="`${this.$api.getBaseUrl()}/api/plugin/video-tool/download-latest`"
            @click="download('mac')"
          >Mac端下载</a>
        </div>
      </div>
</template>

<script>
import { uploadBussinessLog } from "@/js/utils/bussinessLog";
export default {
  data() {
    return {};
  },
  methods: {
    onActivityClick() {
      console.log("this.$api.getNiushishuoUrl()", this.$api.getNiushishuoUrl());
      window.open(`${this.$api.getNiushishuoUrl()}/#/activity`, "_blank");
    },
    download(os) {
      if (os == "win") {
        uploadBussinessLog("035fe083215f0881f6747b3ae9bc033a", "click");
      } else {
        uploadBussinessLog("3f9a793be5b1ea880e8b254267a2f32f", "click");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 500px;
  background-image: url("../../../assets/images/website/banner.jpg");
  background-size: contain;
  background-repeat: no-repeat;
  background-size: center;
  position: relative;
  .downloadbutton {
    display: inline-block;
    width: 220px;
    height: 58px;
    background: #ffffff;
    border-radius: 29px;
    position: absolute;
    top: 320px;
    &.win {
      left: 360px;
    }
    &.mac {
      left: 616px;
    }
    &:hover {
      box-shadow: 0px 6px 5px 1px rgba(0, 28, 185, 0.2);
    }
    a {
      width: 100%;
      height: 48px;
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #435fff;
      line-height: 48px;
      text-decoration: none;
      z-index: 1;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }
  }
}
>>> .el-carousel__container {
  height: 500px;
  z-index: 0;
}
.activityBanner {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/website/components/download.vue